import { render, staticRenderFns } from "./index22.vue?vue&type=template&id=2fdd2300&scoped=true"
import script from "./index22.vue?vue&type=script&lang=js"
export * from "./index22.vue?vue&type=script&lang=js"
import style0 from "./index22.vue?vue&type=style&index=0&id=2fdd2300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd2300",
  null
  
)

export default component.exports